import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const insightsPortalAccessControl: DomainAccessControlConfig = {
  permissions: Permission.Performance,
}
